module.exports = __webpack_public_path__ + "img/wechatqr.9b98f516.jpg";